const numberFormats = {
  en: {
    currency: { style: "currency", currency: "USD" }
  },
  ru: {
    currency: { style: "currency", currency: "USD", currencyDisplay: "code" }
  }
}

export default numberFormats
